import { Box } from "@mui/material";
import type { ReactNode } from "react";

/**
 * Small grey count pill — reusable label chip used in the sidebar
 * "Suggestions · 29" affordance and inline metric captions like
 * "4 of 29 closed" on the Overview hero. Neutral grey background,
 * 4px corner radius, tabular-nums so multi-digit values stay aligned.
 *
 * Pass either `value` (single number) or `children` (free-form string
 * like "4 / 29") for the inline-caption use case.
 */
export interface CountChipProps {
  value?: number | string | null;
  children?: ReactNode;
}

export default function CountChip({ value, children }: CountChipProps) {
  const content = children ?? value;
  if (content == null || content === "") return null;
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 28,
        height: 22,
        px: 0.75,
        borderRadius: "4px",
        bgcolor: "action.selected",
        color: "text.primary",
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1,
        fontVariantNumeric: "tabular-nums",
      }}
    >
      {content}
    </Box>
  );
}
